import { Navigate, Route, Routes } from "react-router-dom";
import { Header } from "./components/Header";
import { AlreadyCompleted } from "./pages/AlreadyCompleted";
import { Complete } from "./pages/Complete";
import { Interview } from "./pages/Interview";
import { StudyClosed } from "./pages/StudyClosed";
import { TooShort } from "./pages/TooShort";

/**
 * Participant flow router (architecture §5.1, §5.6).
 *
 * /interview is the single entry point — it handles BOTH the autologin path
 * (`?d=<base64url>` from Customer.io) AND the admin-QA path (`?studyId=<uuid>`,
 * email typed by the admin). The prototype's separate /welcome + /email pages
 * are merged into /interview's internal "stages".
 *
 * Post-flow routes:
 *   /complete           — interview finished, cleared the 30s pre-filter
 *   /too-short          — interview ended below 30s (retry allowed)
 *   /already-completed  — 409 already_completed from initiate
 *   /study-closed       — 409 study_closed from initiate
 */
export default function App() {
  return (
    <div className="min-h-svh w-full bg-surface-muted flex flex-col">
      <Header />
      {/* Centering via the child's `my-auto` (NOT items-center on the
          parent): when content is taller than the viewport — small phones,
          Slack's in-app browser — flex centering clips the top above the
          screen with no way to scroll to it. margin-auto centers when there
          is room and degrades to a normal scrollable flow when there isn't. */}
      <main className="flex-1 flex flex-col items-center px-4 pb-8 sm:pb-14">
        <div className="my-auto w-full flex justify-center py-4 sm:py-6">
          <Routes>
            <Route path="/" element={<Navigate to="/interview" replace />} />
            <Route path="/interview" element={<Interview />} />
            <Route path="/complete" element={<Complete />} />
            <Route path="/too-short" element={<TooShort />} />
            <Route path="/already-completed" element={<AlreadyCompleted />} />
            <Route path="/study-closed" element={<StudyClosed />} />
            <Route path="*" element={<Navigate to="/interview" replace />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}
